import { FC } from 'react'

// import WidgetYaBage from 'components/parts/widget-ya-bage/widget-ya-bage'
import MedpointYaBage from 'components/parts/medpoint-ya-bage/medpoint-ya-bage'
import Button from 'components/parts/button/button'

import commonStyle from 'styles/course/course.module.scss'
import styles from './course-cost.module.scss'

interface ICourseCost {
  isNotAuthorized: boolean
  price: number
  onClickOut: () => void
}

const CourseCost: FC<ICourseCost> = ({ isNotAuthorized, price, onClickOut }) => {
  return (
    <div className={commonStyle.sectionSpace}>
      <h2 className={commonStyle.title}>Стоимость курса</h2>
      <div className={styles.wrapper}>
        <div className={styles.splitInfo}>
          <div className={styles.price}>{price} ₽</div>
          <div>
            <MedpointYaBage price={price} />
          </div>
        </div>
        <div className={styles.siteInfo}>
          {isNotAuthorized && (
            <>
              <div className={styles.titleNoAuth}>
                Войдите в свой аккаунт, чтобы выбрать способ оплаты
              </div>
              <Button onClick={onClickOut}>Войти в аккаунт</Button>
            </>
          )}
          {!isNotAuthorized && (
            <>
              <div className={styles.titleAuth}>
                Оплатите удобным для вас способом: банковской картой, в рассрочку или&nbsp;за счет
                средств ОМС
              </div>
              <Button onClick={onClickOut}>Выбрать способ оплаты</Button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default CourseCost
